<template>
  <div class="moduleStyle minHeight labelManagementPage">
    <div class="label-container">
      <!-- 左侧标签侧边栏 (宽度缩小1/3) -->
      <div class="sidebar-panel">
        <div class="sidebar-header">
          <span class="title">标签</span>
          <el-button size="mini" type="primary" icon="el-icon-plus" circle @click="newlyAdded"></el-button>
        </div>
        <div class="sidebar-search">
          <el-input v-model="basicListconfig.searchParameters.keywords" placeholder="搜索" size="small" prefix-icon="el-icon-search" clearable @input="getlist"></el-input>
        </div>
        <div class="sidebar-list" v-loading="basicListconfig.loading">
          <div v-for="item in basicListconfig.data" :key="item.id" class="tag-item" :class="{ active: currentLabelId == item.id }" @click="handleLabelClick(item)">
            <span class="tag-name">{{ item.label_name }}</span>
            <div class="tag-actions">
              <i class="el-icon-edit" @click.stop="editButton(item)"></i>
              <i class="el-icon-delete" @click.stop="deleteRows(item)"></i>
            </div>
          </div>
          <div v-if="basicListconfig.data.length === 0" class="empty-text">暂无</div>
        </div>
      </div>

      <!-- 右侧商品管理区 -->
      <div class="content-panel">
        <div class="content-header" v-if="currentLabelId">
          <div class="tag-title">
            <i class="el-icon-collection-tag"></i> {{ currentLabelName }}
          </div>
          <div class="actions">
            <el-button size="small" type="primary" icon="el-icon-plus" @click="openBindDialog">添加商品</el-button>
            <el-button size="small" type="danger" icon="el-icon-delete" :disabled="selectedStockItemIds.length === 0" @click="batchRemove">批量移除</el-button>
          </div>
        </div>
        
        <div class="table-area" v-if="currentLabelId">
          <basicList :config="goodsListConfig" @search="searchGoodsEvent" @handleSelectionChange="handleGoodsSelectionChange">
            <!-- 自定义商品名称列：展示条码 -->
            <template v-slot:name="row">
              <div class="product-info-cell">
                <div class="p-name">{{ row.row.name }}</div>
                <div class="p-barcode">{{ row.row.item_number || '--' }}</div>
              </div>
            </template>
            <template v-slot:operation="row">
              <el-button type="text" style="color:#F56C6C" size="mini" @click="singleRemove(row.row)">移除</el-button>
            </template>
          </basicList>
        </div>
        
        <div v-else class="welcome-area">
          <i class="el-icon-price-tag" style="font-size: 48px; color: #E4E7ED; margin-bottom: 20px;"></i>
          <p>请选择标签进行管理</p>
        </div>
      </div>
    </div>

    <!-- 批量添加弹窗 -->
    <el-dialog title="批量添加商品" :visible.sync="bindDialog.visible" width="1100px" append-to-body :close-on-click-modal="false">
      <basicList :config="bindGoodsListConfig" @search="searchBindGoodsEvent" @handleSelectionChange="handleBindGoodsSelectionChange">
        <!-- 修复弹窗内商品名称不显示的问题 -->
        <template v-slot:name="row">
          <div class="product-info-cell">
            <div class="p-name">{{ row.row.name }}</div>
            <div class="p-barcode">{{ row.row.item_number || '--' }}</div>
          </div>
        </template>
      </basicList>
      <div slot="footer">
        <el-button size="small" @click="bindDialog.visible = false">取消</el-button>
        <el-button size="small" type="primary" :disabled="bindDialog.selectedIds.length === 0" @click="batchAdd">确认添加</el-button>
      </div>
    </el-dialog>

    <formWindow :dialogParams="dialogParams" @close="closeThePopUpWindow"></formWindow>
  </div>
</template>

<script>
import { getItemlabelList, itemLabelDel, getStockItemListByLabel, getCanBindStockItemList, batchBindStockItem, batchUnbindStockItem, itemClassGetList } from "@/api/basicConfiguration";
const defaultGoodsParams = { page: 1, limit: 10, keywords: "", class_id: null };
const goodsCols = [
  { label: "商品ID", prop: "item_id", width: 80 },
  { label: "商品名称/条码", prop: "name", width: 280, slot: true },
  { label: "分类", prop: "class_pname", width: 120 },
  { label: "子分类", prop: "class_name", width: 120 },
  { label: "商户库存", prop: "num", width: 100 },
  { label: "成本价", prop: "avg_price", width: 100, isMoney: true },
  { label: "状态", prop: "item_status_text", width: 80 }
];

export default {
  name: "labelManagement",
  components: { formWindow: () => import("./formWindow.vue") },
  data() {
    return {
      roleId: 0, compId: 0, currentLabelId: "", currentLabelName: "",
      selectedStockItemIds: [],
      dialogParams: { key: new Date().getTime(), visible: false, id: "" },
      basicListconfig: { loading: false, data: [], searchParameters: { page: 1, limit: 500, keywords: "" } },
      goodsListConfig: {
        loading: false, check: true, data: [], column: goodsCols, isPage: true, total: 0, 
        operationWidth: 80, 
        search: [
          { label: "名称/条码", type: "input", key: "keywords" },
          { label: "商品分类", type: "treeselect", key: "class_id", options: [] }
        ],
        searchParameters: Object.assign({}, defaultGoodsParams)
      },
      bindDialog: { visible: false, selectedIds: [] },
      bindGoodsListConfig: {
        loading: false, check: true, data: [], column: goodsCols, isPage: true, total: 0,
        operation: false, // 弹窗不需要操作栏
        search: [
          { label: "名称/条码", type: "input", key: "keywords" },
          { label: "商品分类", type: "treeselect", key: "class_id", options: [] }
        ],
        searchParameters: Object.assign({}, defaultGoodsParams)
      }
    };
  },
  created() { 
    this.roleId = this.$store.getters.userRole; 
    this.compId = this.$store.getters.userInfo.compId; 
    this.getlist(); 
    this.obtainDataSource();
  },
  methods: {
    format(list) { return (list || []).map(i => ({ ...i, item_status_text: i.item_status == 0 ? "上架" : "下架" })); },
    getlist() {
      this.basicListconfig.loading = true;
      getItemlabelList(this.basicListconfig.searchParameters).then(res => {
        this.basicListconfig.loading = false;
        if (res.code == 1) {
          this.basicListconfig.data = res.data || [];
          if (!this.currentLabelId && this.basicListconfig.data.length > 0) this.handleLabelClick(this.basicListconfig.data[0]);
        }
      });
    },
    handleLabelClick(row) {
      this.currentLabelId = row.id; this.currentLabelName = row.label_name;
      this.selectedStockItemIds = [];
      this.goodsListConfig.searchParameters = Object.assign({}, defaultGoodsParams);
      this.getGoodsList();
    },
    getGoodsList() {
      this.goodsListConfig.loading = true;
      getStockItemListByLabel({ comp_id: this.compId, label_id: this.currentLabelId, ...this.goodsListConfig.searchParameters }).then(res => {
        this.goodsListConfig.loading = false;
        if (res.code == 0) { this.goodsListConfig.data = this.format(res.data); this.goodsListConfig.total = res.count || 0; }
      });
    },
    handleGoodsSelectionChange(val) { this.selectedStockItemIds = (val || []).map(i => i.id); },
    singleRemove(row) { this.doRemove([row.id]); },
    batchRemove() { this.doRemove(this.selectedStockItemIds); },
    doRemove(ids) {
      this.$confirm(`确定移除选中的 ${ids.length} 个商品?`, "提示", { type: "warning" }).then(() => {
        batchUnbindStockItem({ comp_id: this.compId, label_id: this.currentLabelId, stock_item_ids: ids }).then(res => {
          if (res.code == 1) { this.$message.success("操作成功"); this.getGoodsList(); }
        });
      });
    },
    openBindDialog() {
      this.bindDialog.visible = true; this.bindDialog.selectedIds = [];
      this.bindGoodsListConfig.searchParameters = Object.assign({}, defaultGoodsParams);
      this.getCanBindGoodsList();
    },
    getCanBindGoodsList() {
      this.bindGoodsListConfig.loading = true;
      getCanBindStockItemList({ comp_id: this.compId, label_id: this.currentLabelId, ...this.bindGoodsListConfig.searchParameters }).then(res => {
        this.bindGoodsListConfig.loading = false;
        if (res.code == 0) { this.bindGoodsListConfig.data = this.format(res.data); this.bindGoodsListConfig.total = res.count || 0; }
      });
    },
    batchAdd() {
      batchBindStockItem({ comp_id: this.compId, label_id: this.currentLabelId, stock_item_ids: this.bindDialog.selectedIds }).then(res => {
        if (res.code == 1) { this.$message.success("添加成功"); this.bindDialog.visible = false; this.getGoodsList(); }
      });
    },
    deleteRows(row) {
      this.$confirm("确定删除该标签?", "提示", { type: "warning" }).then(() => {
        itemLabelDel({ id: row.id }).then(res => {
          if (res.code == 1) { this.$message.success("删除成功"); if (this.currentLabelId == row.id) this.currentLabelId = ""; this.getlist(); }
        });
      });
    },
    editButton(row) { this.dialogParams = { key: Date.now(), visible: true, id: row.id }; },
    newlyAdded() { this.dialogParams = { key: Date.now(), visible: true, id: "" }; },
    closeThePopUpWindow() { this.dialogParams.visible = false; this.getlist(); },
    searchGoodsEvent(d, p, s) { if (p) this.goodsListConfig.searchParameters.page = p; if (s) this.goodsListConfig.searchParameters.limit = s; if (d) Object.assign(this.goodsListConfig.searchParameters, d); this.getGoodsList(); },
    searchBindGoodsEvent(d, p, s) { if (p) this.bindGoodsListConfig.searchParameters.page = p; if (s) this.bindGoodsListConfig.searchParameters.limit = s; if (d) Object.assign(this.bindGoodsListConfig.searchParameters, d); this.getCanBindGoodsList(); },
    handleBindGoodsSelectionChange(v) { this.bindDialog.selectedIds = (v || []).map(i => i.id); },
    obtainDataSource() {
      itemClassGetList().then((res) => {
        if (res.code == 1) {
          const options = this.$findChildren(0, res.data);
          this.goodsListConfig.search[1].options = options;
          this.bindGoodsListConfig.search[1].options = options;
        }
      });
    },
  }
};
</script>

<style scoped>
.label-container { display: flex; height: calc(100vh - 120px); background: #fff; border: 1px solid #ebeef5; overflow: hidden; }
.sidebar-panel { width: 160px; border-right: 1px solid #ebeef5; display: flex; flex-direction: column; flex-shrink: 0; }
.sidebar-header { padding: 12px; display: flex; justify-content: space-between; align-items: center; background: #f8f9fb; border-bottom: 1px solid #ebeef5; }
.sidebar-header .title { font-weight: bold; font-size: 14px; }
.sidebar-search { padding: 8px; }
.sidebar-list { flex: 1; overflow-y: auto; }
.tag-item { padding: 10px 12px; cursor: pointer; display: flex; justify-content: space-between; align-items: center; transition: all 0.2s; border-bottom: 1px solid #fafafa; font-size: 13px; }
.tag-item:hover { background: #f5f7fa; }
.tag-item.active { background: #ecf5ff; color: #409eff; font-weight: bold; border-right: 3px solid #409eff; }
.tag-actions { display: none; gap: 6px; }
.tag-item:hover .tag-actions { display: flex; }
.tag-actions i { color: #909399; font-size: 13px; }
.tag-actions i:hover { color: #409eff; }

.content-panel { flex: 1; display: flex; flex-direction: column; padding: 15px; overflow: hidden; }
.content-header { display: flex; justify-content: space-between; align-items: center; margin-bottom: 15px; padding-bottom: 10px; border-bottom: 1px solid #f2f6fc; }
.tag-title { font-size: 16px; font-weight: bold; color: #303133; }
.table-area { flex: 1; overflow: auto; display: flex; flex-direction: column; }

.product-info-cell { display: flex; flex-direction: column; line-height: 1.4; }
.p-name { color: #303133; font-weight: 500; font-size: 14px; white-space: normal; word-break: break-all; }
.p-barcode { color: #909399; font-size: 12px; margin-top: 2px; }

.welcome-area { flex: 1; display: flex; flex-direction: column; align-items: center; justify-content: center; color: #909399; }
.empty-text { padding: 20px; text-align: center; color: #c0c4cc; font-size: 12px; }

/* 修复分页过大导致的显示问题 */
.basicList { height: 100%; display: flex; flex-direction: column; }
.table { flex: 1; overflow: hidden; }
.el-table { height: 100% !important; }
</style>


// WEBPACK FOOTER //
// src/views/labelManagement/index.vue